import React from 'react';
import { Formik } from 'formik';
import Loading from 'components/common/loading/Loading';
import { useMutation, useQuery } from 'react-query';
import { initialValues, validationSchema } from 'components/kb/utils';
import { CREATE_MACRO } from 'components/kb/queries';
import { CustomHook } from 'utils/custom-hook';
import NewMacro from './NewMacro';
import { useEditor } from '@wysimark/react';

const NewMacroContainer = () => {
  const { mutationProps } = CustomHook();
  const { data: ticketDepartment, isLoading: depLoading } = useQuery('/admin/tickets/departments');
  const { data: ticketDepName, isLoading: depNameLoading } = useQuery('/admin/tickets/department/definitions');
  const { mutate: createMacro, isLoading: loadingCreateMacro } = useMutation(CREATE_MACRO);
  const editor = useEditor({ initialMarkdown: '', minHeight: 480 });

  const handleSubmitMacro = async (values, resetForm) => {
    await createMacro(
      {
        department: values.department,
        language: values.language,
        subject: btoa(values.subject),
        message: btoa(values.message),
        label: values.label,
        keywords: values.keywords,
      },
      mutationProps(() => {}, {
        onSuccess: (e) => {
          resetForm();
          // editor.resetMarkdown();
        },
      }),
    );
  };
  if (depLoading && depNameLoading) {
    <Loading />;
  }
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { resetForm }) => handleSubmitMacro(values, resetForm)}
    >
      {(formikProp) => (
        <NewMacro
          formikProp={formikProp}
          ticketDepartment={ticketDepartment}
          ticketDepName={ticketDepName}
          loadingCreateMacro={loadingCreateMacro}
          editor={editor}
        />
      )}
    </Formik>
  );
};
export default NewMacroContainer;
